import { styled } from 'styled-components';
export const AssetImage = styled.img.withConfig({
  displayName: "AssetImage",
  componentId: "sc-z88iwf-0"
})(["object-fit:cover;object-position:50% 50%;width:100%;height:100%;"]);